// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ChatOutlineGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M3.833 19.133h-.367c-.3 0-.566-.233-.633-.533-.067-.3.1-.6.367-.733 0 0 1.133-.6 1.766-1.7-1.366-1.467-2.133-3.3-2.133-5.2 0-4.467 4.2-8.134 9.333-8.134 3.634 0 6.967 1.867 8.467 4.734a7.26 7.26 0 0 1 .867 3.4c0 .366-.3.666-.667.666a.669.669 0 0 1-.667-.666c0-.967-.233-1.9-.7-2.8-1.3-2.434-4.166-4-7.3-4-4.4 0-8 3.066-8 6.8 0 1.666.734 3.3 2.067 4.566.2.2.267.467.167.734a5.05 5.05 0 0 1-.867 1.366c.7-.1 1.467-.333 2.067-.7a.619.619 0 0 1 .633-.033c.3.133.6.267.9.367l.3.1c.367.1.533.466.433.833-.1.367-.466.533-.833.433-.1-.033-.233-.066-.333-.1-.234-.1-.5-.166-.734-.3-1.466.8-3.333.9-4.133.9Zm24.7 10.034a.61.61 0 0 0 .6-.534c.033-.3-.067-.6-.367-.733 0 0-1.133-.6-1.766-1.7 1.4-1.467 2.133-3.3 2.133-5.2 0-4.5-4.2-8.133-9.333-8.133-5.134 0-9.334 3.666-9.334 8.133.034 4.5 4.234 8.167 9.367 8.167 1.433 0 2.867-.3 4.167-.867 1.5.767 3.366.867 4.166.867h.367Zm-.7-8.167c0 1.667-.733 3.3-2.067 4.567-.2.2-.266.466-.166.733.233.533.533 1 .866 1.367-.7-.1-1.466-.334-2.066-.7a.619.619 0 0 0-.634-.034c-1.2.6-2.566.9-3.933.9-4.4 0-8-3.066-8-6.8 0-3.733 3.6-6.8 8-6.8s8 3.034 8 6.767Z"
			fill="url(#ChatOutlineGradient_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="ChatOutlineGradient_tsx__a"
				x1={2.818}
				y1={2.833}
				x2={29.152}
				y2={29.154}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B275F0" />
				<stop offset={1} stopColor="#F0758A" />
			</linearGradient>
		</defs>
	</svg>
);
export default ChatOutlineGradient;
